(() => {
  const GROUPS = ['hydrolate', 'pflanzenoele', 'buttern-wachse', 'aetherische-oele', 'tonerden-mineralien', 'tenside', 'weitere'];

  async function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const list = root.querySelector('[data-lex-list]');
    const nav = root.querySelector('[data-lex-nav]');
    const input = root.querySelector('[data-lex-search]');
    const status = root.querySelector('[data-lex-status]');
    const filterBar = root.querySelector('[data-lex-filter]');
    const filterButtons = filterBar ? Array.from(filterBar.querySelectorAll('[data-filter]')) : [];
    const norm = value => value.toLocaleLowerCase('de').normalize('NFD').replace(/\p{Diacritic}/gu, '');
    let activeFilter = 'alle';

    function applyFilters() {
      const query = norm(input.value.trim());
      let count = 0;
      list.querySelectorAll('article').forEach(item => {
        const matchesFilter = activeFilter === 'alle' || item.dataset.lexCat === activeFilter;
        const matchesSearch = !query || norm(item.textContent).includes(query);
        const visible = matchesFilter && matchesSearch;
        item.hidden = !visible;
        if (visible) count++;
      });
      // Texte aus den Locale-Dateien (sd.lexicon.status_*), als data-text-* am Statusfeld gerendert.
      const vorlage = (list.dataset.next ? 'textPartial' : 'textAll') + (query ? 'Found' : '');
      status.textContent = (status.dataset[vorlage] || '').replace('[count]', count);
    }

    function setActiveFilter(slug, updateHash) {
      activeFilter = GROUPS.includes(slug) ? slug : 'alle';
      filterButtons.forEach(btn => {
        btn.setAttribute('aria-pressed', btn.dataset.filter === activeFilter ? 'true' : 'false');
      });
      if (updateHash) {
        const hash = activeFilter === 'alle' ? '' : `#filter-${activeFilter}`;
        history.replaceState(null, '', location.pathname + location.search + hash);
      }
      applyFilters();
    }

    // L4: Zurück-nach-oben erscheint nach etwas Scrollen, nur auf der Lexikonseite
    const top = root.querySelector('[data-lex-top]');
    if (top) {
      const toggle = () => top.classList.toggle('is-visible', window.scrollY > 600);
      window.addEventListener('scroll', toggle, { passive: true });
      toggle();
      top.addEventListener('click', () => {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
        const h1 = root.querySelector('h1');
        if (h1) { h1.setAttribute('tabindex', '-1'); h1.focus({ preventScroll: true }); }
      });
    }

    input.addEventListener('input', applyFilters);
    filterButtons.forEach(btn => {
      btn.addEventListener('click', () => setActiveFilter(btn.dataset.filter, true));
    });

    // S1: Sprung zu einem einzelnen Eintrag (#handle). Der Eintrag kann auf einer der nachgeladenen
    // Seiten stehen, deshalb nach jedem Ladeschritt erneut anspringen, bis er da ist. Der feste Kopfbereich
    // wird über scroll-padding-top der Seite (theme.css) berücksichtigt.
    let eintragGesprungen = false;
    function zumEintrag() {
      if (eintragGesprungen) return;
      const id = decodeURIComponent(location.hash.slice(1));
      if (!id || id.startsWith('filter-')) return;
      const ziel = document.getElementById(id);
      if (!ziel || !list.contains(ziel)) return;
      eintragGesprungen = true;
      if (activeFilter !== 'alle' || input.value) { input.value = ''; setActiveFilter('alle', false); }
      ziel.classList.add('sd-lex__i--ziel');
      requestAnimationFrame(() => ziel.scrollIntoView({ block: 'start' }));
      setTimeout(() => ziel.scrollIntoView({ block: 'start' }), 600);
    }

    const hashMatch = /^#filter-([a-z-]+)$/.exec(location.hash);
    if (hashMatch && GROUPS.includes(hashMatch[1])) {
      setActiveFilter(hashMatch[1], false);
    } else {
      applyFilters();
    }

    zumEintrag();
    const seen = new Set();
    while (list.dataset.next) {
      const url = new URL(list.dataset.next, location.href);
      if (url.origin !== location.origin || seen.has(url.href)) break;
      seen.add(url.href);
      try {
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('load failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = doc.querySelector('[data-lex-list]');
        if (!next) throw new Error('missing list');
        const ids = new Set(Array.from(list.children, item => item.id));
        Array.from(next.children).forEach(item => { if (!ids.has(item.id)) list.append(document.importNode(item, true)); });
        list.dataset.next = next.dataset.next || '';
        const link = nav?.querySelector('a');
        if (link && list.dataset.next) link.href = list.dataset.next;
        applyFilters();
        zumEintrag();
      } catch (_) {
        if (status.dataset.textLoadError) status.textContent += ' ' + status.dataset.textLoadError;
        break;
      }
    }
    if (nav && !list.dataset.next) nav.hidden = true;
  }
  const mount = () => document.querySelectorAll('[data-sd-lexikon]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
